import { forwardRef, Ref } from 'react';

import { getFieldStyles } from '../../utils';
import { PDFFieldProps } from '../../types';
import classNames from 'classnames';
import styles from './styles.module.scss';
import Text from '../Text';

type DateProps = PDFFieldProps;

const Date = ({ field, onComplete }: DateProps, ref: Ref<HTMLElement>) => {
  if (!field.linkedSignatureField) {
    return <Text field={field} onComplete={onComplete} ref={ref} />;
  }

  return (
    <div
      ref={ref as Ref<HTMLDivElement>}
      className={classNames(styles.date, { [styles.pending]: !field.value })}
      style={getFieldStyles(field)}
    >
      {field.value ?? ''}
    </div>
  );
};

export default forwardRef<HTMLElement, DateProps>(Date);
